// extracted by mini-css-extract-plugin
export default {"SubSection":"WildlifeManagement-PDF-style_SubSection__1ISas","Disclaimer":"WildlifeManagement-PDF-style_Disclaimer__3671H","Bordered":"WildlifeManagement-PDF-style_Bordered__g-ilM"};